import { Divider, Typography } from "antd";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import ComponentHeader from "../../../core/ComponentHeader";
import SubmitButton from "../../../core/SubmitButton";

const { Title, Text } = Typography;

const PartyMessagesDetail = props => {
  const partyMessage = props.partyMessage;
  return (
    <div className="container">
      <div className="tabVerticalSize" />
      <ComponentHeader
        title={labels.partyMessageDetailTitle}
        id={partyMessage ? partyMessage.id : undefined}
        showBackButton
      />
      <div className="bordered_bottom_rounded containerShadow">
        {partyMessage ? (
          <div>
            <Row>
              <Col className="tableButtons">
                <Text>{partyMessage.dispatchDate}</Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Col>
                  <Title className="partyMessageTitle" level={4}>
                    {partyMessage.name}
                  </Title>
                </Col>
              </Col>
            </Row>
            <Divider className="message-divider" />
            <Row>
              <Col>
                <Text className="message-content">{partyMessage.content}</Text>
              </Col>
            </Row>
            {props.entity ? (
              <Row>
                <Col>
                  <SubmitButton
                    type="link"
                    className="link-button"
                    text={labels.entityLink}
                    onClick={props.openEntity}
                    openInNewTab={props.openEntityInNewTab}
                  />
                </Col>
              </Row>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PartyMessagesDetail;
